import { render, staticRenderFns } from "./form-base-custom.vue?vue&type=template&id=24c70eb6"
import script from "./form-base-custom.vue?vue&type=script&lang=js"
export * from "./form-base-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports